module.exports = __webpack_public_path__ + "img/1.cb9f991e.jpg";